import { TrackType } from './enums';

export const TrackMessage = {
  [TrackType.SWAP]: 'Swap {name} initiated successfully. Waiting for the result...',
  [TrackType.Deposit]: 'Waiting for the deposit {name}...',
  [TrackType.Withdraw]: 'Waiting for the withdraw {name}...',
  [TrackType.CreateBid]: 'Waiting for the {name} Bid creation...',
  [TrackType.CreatePactOrder]: 'Waiting for the {name} Pact order creation...',
  [TrackType.CancelBid]: 'Waiting for the {name} Bid cancel...',
  [TrackType.CancelPactOrder]: 'Waiting for the {name} Pact order cancel...',
  [TrackType.Finalize]: 'Finalize {name} initiated successfully. Waiting for the result...',
};

export const SuccessMessage = {
  [TrackType.SWAP]: 'Swap {name} processed successfully',
  [TrackType.Deposit]: 'Deposit {name} processed successfully',
  [TrackType.Withdraw]: 'Withdraw {name} processed successfully',
  [TrackType.CreateBid]: '{name} Bid created',
  [TrackType.CreatePactOrder]: '{name} Pact order created',
  [TrackType.CancelBid]: '{name} Bid cancelled',
  [TrackType.CancelPactOrder]: '{name} Pact order cancelled',
  [TrackType.Finalize]: 'Finalize {name} processed successfully',
};

export const ErrorMessage = {
  [TrackType.SWAP]: 'Swap {name} failed',
  [TrackType.Deposit]: 'Deposit {name} failed',
  [TrackType.Withdraw]: 'Withdraw {name} failed',
  [TrackType.CreateBid]: '{name} Bid creation failed',
  [TrackType.CreatePactOrder]: '{name} Pact order creation failed',
  [TrackType.CancelBid]: '{name} Bid cancel failed',
  [TrackType.CancelPactOrder]: '{name} Pact order cancel failed',
  [TrackType.Finalize]: 'Finalize {name} failed',
};
